import {ContentBox} from '@hconnect/common/components/ContentBox'
import {Box} from '@mui/material'
import {AxiosError} from 'axios'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {EXPERT_SYSTEM_WIDGET_NAMESPACE} from '../consts'
import type {EquipmentExpertSystemUsage} from '../types'

import {ExpertSystemEquipmentCharts} from './ExpertSystemEquipmentCharts'

type ExpertSystemWrapperProps = {
  canDisplayMultiMonthData: boolean
  isLoading: boolean
  error: AxiosError | null
  expertSystemEquipments?: EquipmentExpertSystemUsage[]
}

export const ExpertSystemWrapper: FC<ExpertSystemWrapperProps> = ({
  canDisplayMultiMonthData,
  error,
  expertSystemEquipments,
  isLoading
}) => {
  const {t} = useTranslation(EXPERT_SYSTEM_WIDGET_NAMESPACE)

  return !canDisplayMultiMonthData || error || !expertSystemEquipments?.length ? (
    <ContentBox
      title={t('expertSystemUtilization.cardTitle')}
      mode="contentDependentHeight"
      bodyWithPadding
      data-test-id="expert-system-section"
      isLoading={isLoading}
    >
      {error && (
        <Box component="span" data-test-id="expert-system-error-label">
          {t('expertSystemUtilization.message.error')}
        </Box>
      )}
      {!error && canDisplayMultiMonthData && !expertSystemEquipments?.length && !isLoading && (
        <Box component="span" data-test-id="expert-system-empty-label">
          {t('expertSystemUtilization.message.noData')}
        </Box>
      )}
      {!error && !canDisplayMultiMonthData && (
        <Box component="span" data-test-id="expert-system-unavailable-label">
          {t('expertSystemUtilization.message.unavailable')}
        </Box>
      )}
    </ContentBox>
  ) : (
    <ContentBox
      mode="max100PercentOfParentHeight"
      title={t('expertSystemUtilization.cardTitle')}
      bodyWithPadding
      data-test-id="expert-sys-util"
    >
      <ExpertSystemEquipmentCharts expertSystemEquipments={expertSystemEquipments} />
    </ContentBox>
  )
}
